import {useState, useEffect} from 'react';

import {MenuConfig} from './AdminRoutes';
import {useAuthStore} from '@/context/auth';

export function useMenuService() {
    const [authStore] = useAuthStore();
    const [menus, setMenus] = useState([]);

    useEffect(() => {
        const authMenus = MenuConfig.filter(item => {
            // 无权限要求的菜单项总是显示
            if (!item.authorities) return true;
            return authStore.hasAuthorities(item.authorities, 'r');
        }).map(item => {
            // 处理子菜单
            if (item.children) {
                const visibleChildren = item.children.filter(child => {
                    if (!child.authorities) return true;
                    return authStore.hasAuthorities(child.authorities, 'r');
                });
                return {...item, children: visibleChildren};
            }
            return item;
        });
        setMenus(authMenus);
    }, [authStore]);

    return menus;
}

export function useEditAuthService(auths) {
    const [authStore] = useAuthStore();

    const [editable, setEditable] = useState(false);

    useEffect(() => {
        setEditable(authStore.hasAuthorities(auths, 'w'));
    }, [authStore, auths]);

    return editable;
}

export function useHasAdminAuthService() {
    const [authStore] = useAuthStore();
    const [globalAuth, setGlobalAuth] = useState(false);

    useEffect(() => {
        setGlobalAuth(authStore.hasGlobalAuths());
    }, [authStore]);

    return globalAuth;
}

/**
 * 顶部导航栏权限检查 - 分别控制会话留存、客户管理、系统管理入口显示
 */
export function useTopNavAuthService() {
    const [authStore] = useAuthStore();
    const [navAuth, setNavAuth] = useState({
        conversationEntry: false,
        customerEntry: false,
        adminEntry: false,
    });

    useEffect(() => {
        const authorities = authStore.authorities ?? [];
        if (authorities.length === 0) return;

        const GLOBAL_ADMIN_READ = 'global:admin:r';
        const GLOBAL_ADMIN_WRITE = 'global:admin:w';

        setNavAuth({
            conversationEntry: !!authorities.find(
                auth => auth.startsWith('global:conversation') || auth === GLOBAL_ADMIN_READ || auth === GLOBAL_ADMIN_WRITE
            ),
            customerEntry: !!authorities.find(
                auth => auth.startsWith('global:customer') || auth === GLOBAL_ADMIN_READ || auth === GLOBAL_ADMIN_WRITE
            ),
            adminEntry: !!authorities.find(
                auth => auth.startsWith('global:sys_') || auth === 'global:app' || auth.startsWith('global:depart') ||
                         auth.startsWith('global:role') || auth.startsWith('global:tag') ||
                         auth.startsWith('global:corp') || auth.startsWith('global:clientApp') ||
                         auth.startsWith('global:log') || auth === GLOBAL_ADMIN_READ || auth === GLOBAL_ADMIN_WRITE
            ),
        });
    }, [authStore]);

    return navAuth;
}
